﻿import ReduxThunk from 'redux-thunk';
import { createStore, combineReducers, Store, applyMiddleware } from 'redux';
import { paragraferReducer } from './Reducers';

const combineRootReducer = combineReducers<AppState>({
    paragraferState: paragraferReducer,
});

//const rootReducer = {
//    paragraferState: paragraferReducer,
//}

export type AppState = {
    paragraferState: ReturnType<typeof paragraferReducer>,
};

// hvordan kjøre createStore uten combineReducers?
export default function configureStore(): Store<AppState> {
    return createStore(combineRootReducer, applyMiddleware(ReduxThunk));
}
